import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpArgumentOperandGroupFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpArgumentOperandDependencyFactory } from "./ExpArgumentOperandDependency";

/**
 * 
 * @export
 * @interface ExpArgumentOperandGroup
 */

export class ExpArgumentOperandGroupFactory {}
_ExpArgumentOperandGroupFactory = ExpArgumentOperandGroupFactory;
_defineProperty(ExpArgumentOperandGroupFactory, "FromJSON", function (json) {
  return _ExpArgumentOperandGroupFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpArgumentOperandGroupFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'selectorLabel': json['selectorLabel'],
    'optional': json['optional'],
    'noOperatorInput': json['noOperatorInput'],
    'noFormulaInput': json['noFormulaInput'],
    'dependencies': json['dependencies'] === null || json['dependencies'] === undefined ? json['dependencies'] : json['dependencies'].map(ExpArgumentOperandDependencyFactory.FromJSON)
  };
});
_defineProperty(ExpArgumentOperandGroupFactory, "ToJSON", function (value) {
  return _ExpArgumentOperandGroupFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpArgumentOperandGroupFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'selectorLabel': value.selectorLabel,
    'optional': value.optional,
    'noOperatorInput': value.noOperatorInput,
    'noFormulaInput': value.noFormulaInput,
    'dependencies': value.dependencies === undefined ? undefined : value.dependencies.map(ExpArgumentOperandDependencyFactory.ToJSON)
  };
});
//# sourceMappingURL=ExpArgumentOperandGroup.js.map
